<template>
    <div>
        <TabButton
            :tabStatusProps="tabStatus"
            @changeTabStatus="changeTabStatus"
        />
        <keep-alive>
            <NoteSection
                v-if="tabStatus === 'note'"
                :noteProps="noteProps"
                :defaultHeight="defaultHeight"
            />
            <Symptom
                v-else
                :selectedScheduleProps="selectedScheduleProps"
                :patientTotalInfoProps="patientTotalInfoProps"
                :windowRefProps="windowRefProps"
                :defaultHeight="defaultHeight"
            />
        </keep-alive>
    </div>
</template>
<script>
import NoteSection from './note';
import Symptom from './symptom';
import TabButton from './tabButton';

export default {
  name: 'selectedScheduleNote',
  components: {NoteSection, Symptom, TabButton},
  props: ['noteProps', 'selectedScheduleProps', 'patientTotalInfoProps', 'windowRefProps'],
  mounted() {
    try {
      const elementItems = this.windowRefProps?.document.getElementById('visitNoteItemBox').getElementsByClassName('item');
      let height = elementItems?.[0]?.offsetHeight + elementItems?.[1]?.offsetHeight + elementItems?.[2]?.offsetHeight + elementItems?.[4]?.offsetHeight;

      this.defaultHeight = `calc(100% - ${height}px)`;
    } catch (e) {
      this.defaultHeight = undefined;
    }
  },
  data() {
    return {
      tabStatus: 'note',
      defaultHeight: undefined,
    }
  },
  methods: {
    changeTabStatus(status) {
      this.tabStatus = status;
    }
  }
}
</script>